import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { Profession } from 'src/shared/features/users/schemas/profession'

type referralParams = {
  query?: string
  exclude_profession?: Profession
  is_closed?: boolean
  needs_action?: boolean
}

export const referrals = createQueryKeys('referrals', {
  detail: (referralId: number) => [referralId],
  points: (referralId: number) => [referralId],
  list: (params: referralParams) => [{ params }],
})
